import { styled, Box, Typography, Chip, Button } from '@mui/material';
import { lighten, darken } from '@mui/material/styles';

interface WhatsappTypeSelectorOptionStyleProps {
  selected: boolean;
}

export const WhatsappTypeSelectorOptionContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'selected',
})<WhatsappTypeSelectorOptionStyleProps>(({ theme, selected }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  border: `1px solid`,
  borderRadius: 12,
  borderColor: selected ? theme.palette.primary.main : theme.palette.grey[400],
  minHeight: 209,
  width: 280,
  padding: 8,
  justifyContent: 'space-between',
  gap: theme.spacing(2),
}));

export const WhatsappTypeSelectorOptionHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(0.75),
  alignItems: 'center',
  flex: 1,
}));

export const WhatsappTypeSelectorOptionHeaderTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<WhatsappTypeSelectorOptionStyleProps>(({ theme, selected }) => ({
  fontWeight: 'bold',
  fontSize: '1.25rem',
  color: selected ? theme.palette.primary.main : theme.palette.grey[600],
}));

export const WhatsappTypeSelectorOptionHeaderSubTitle = styled(Typography)(
  ({ theme }) => ({
    fontSize: '0.85rem',
    textAlign: 'center',
    lineHeight: 1.18,
    color: theme.palette.text.primary,
  }),
);

export const WhatsappTypeSelectorOptionActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  minHeight: 74.5,
}));

export const WhatsappTypeSelectorOptionActionsStatusChip = styled(Chip)(
  ({ theme, color }) => ({
    fontWeight: theme.typography.fontWeightBold,
    textTransform: 'uppercase',
    borderRadius: 6,
    minWidth: 107,

    ...(color &&
      color !== 'default' && {
        backgroundColor: lighten(theme.palette[color].light, 0.5),
        color: darken(theme.palette[color].light, 0.5),
        borderColor: darken(theme.palette[color].light, 0.5),
      }),
  }),
);

export const WhatsappTypeSelectorOptionActionsButton = styled(Button)({
  minWidth: 160,
});

export const WhatsappTypeSelectorOptionHelperText = styled(Typography)(
  ({ theme }) => ({
    fontSize: '0.65rem',
    color: theme.palette.text.secondary,
  }),
);
